export default "__VITE_ASSET__BDTE0k12__"